<template>
    <div>

        <div v-if="this.loading" class="row">
            <div class="col-12">
                <sau-spinner />
            </div>
        </div>

        <div v-else class="row payment-method-row">
            <payment-method-creditcard
                :cardType="paymentMethods.card_type"
                :cardLastFour="paymentMethods.card_last_four"
                :cardExpiry="paymentMethods.card_exp"
                :update="fetchPaymentMethods"
                :spk="spk"
            ></payment-method-creditcard>
            <payment-method-paypal></payment-method-paypal>
            <payment-method-bpay></payment-method-bpay>
            <payment-method-credit :credit="paymentMethods.credit"></payment-method-credit>
        </div>
    </div>
</template>

<script>
import PaymentMethodPaypal from "./PaymentMethodPaypal";
import PaymentMethodCreditcard from "./PaymentMethodCreditcard";
import PaymentMethodBpay from "./PaymentMethodBpay";
import PaymentMethodCredit from "./PaymentMethodCredit";

export default {

    components: {
        "payment-method-creditcard": PaymentMethodCreditcard,
        "payment-method-paypal": PaymentMethodPaypal,
        "payment-method-bpay": PaymentMethodBpay,
        "payment-method-credit": PaymentMethodCredit,
    },

    data() {
        return {
            paymentMethods: [],
            spk: '',
            loading: true,
        };
    },
    mounted() {
        this.fetchPaymentMethods();
    },
    methods: {
        fetchPaymentMethods() {
            this.loading = true;
            this.getPaymentMethods().then(response => {
                this.paymentMethods = response;
                this.spk = response.stripe_public_key;
                this.$store.commit('setUserCredit', response.credit);
            }).finally(() => {
                this.loading = false;
            })
        }
    }
};
</script>

<style lang="scss">
.sau-bx-payment.active:hover {
    z-index: 20;
    position: relative;
}
.payment-method-options {
    position: absolute;
    z-index: 10;
    bottom: 0;
    right: 0;

    .dropbtn {
        font-size: 0.875rem;
    }

    &:hover {
        .dropbtn {
            color: #00ce7d;
        }
    }

    .sau-menu-content {
        button,
        a {
            font-size: 0.875rem;
            color: rbga(0, 0, 0, 0.75);
            margin: 0;
            padding: 0;

            &:hover {
                color: #00ce7d;
            }
            &:not(:last-of-type) {
                margin-bottom: 0.5rem;
            }
        }
    }
}
</style>
